export enum AuthRoutes {
  BASEPATH = "/auth",
  AUTH = "",
  REGISTRATION_COMPLETED = "/registration-completed",
  SIGNUP_WIZARD = "/signup",
  PASSWORD_SIGNUP = "/password",
  SIGNUP = "/step2",
  USAGE_QUESTIONS = "/step3",
  PASSWORD_RECOVERY = "recover",
  SOCIAL_REDIRECT = "/callback",
  VERIFICATION_REQUIRED = "/verification-required",
  VERIFICATION_FAILED = "/verification-failed",
  VERIFICATION_COMPLETED = "/verification-complete",
  LOGOUT = "/logout",
}
